import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import arrowOutwardWhite2 from "@/assets/images/user/arrowOutwardWhite2.svg";
import icInstagram from "@/assets/images/user/icInstagram.svg";
import icPlus from "@/assets/images/user/icPlus.svg";
import logo1box1 from "@/assets/images/user/logo1box1.png";
import logo2box1 from "@/assets/images/user/logo2box1.png";
import logo2box2 from "@/assets/images/user/logo2box2.png";
import logo3box1 from "@/assets/images/user/logo3box1.png";
import logo3box2 from "@/assets/images/user/logo3box2.png";
import logo3box3 from "@/assets/images/user/logo3box3.png";
import logo3box4 from "@/assets/images/user/logo3box4.png";
import logo3box5 from "@/assets/images/user/logo3box5.png";
import logo3box6 from "@/assets/images/user/logo3box6.png";
import logo3box7 from "@/assets/images/user/logo3box7.png";
import logo3box8 from "@/assets/images/user/logo3box8.png";
import logo3box9 from "@/assets/images/user/logo3box9.png";
import logo3box10 from "@/assets/images/user/logo3box10.png";
import logo3box11 from "@/assets/images/user/logo3box11.png";
// import logo3box12 from "@/assets/images/user/logo3box12.png";
// import logo3box13 from "@/assets/images/user/logo3box13.png";
// import logo3box14 from "@/assets/images/user/logo3box14.png";
// import logo3box15 from "@/assets/images/user/logo3box15.png";
import logo3box16 from "@/assets/images/user/logo3box16.png";
import logo3box17 from "@/assets/images/user/logo3box17.png";
import logo3box18 from "@/assets/images/user/logo3box18.png";
import logo4box1 from "@/assets/images/user/logo4box1.png";
import logo4box2 from "@/assets/images/user/logo4box2.png";
import logo4box3 from "@/assets/images/user/logo4box3.png";
import logo4box4 from "@/assets/images/user/logo4box4.png";
import logo4box5 from "@/assets/images/user/logo4box5.png";
import logo4box6 from "@/assets/images/user/logo4box6.png";
import logo4box7 from "@/assets/images/user/logo4box7.png";
import logo4box8 from "@/assets/images/user/logo4box8.png";
import logo4box9 from "@/assets/images/user/logo4box9.png";
import logo4box10 from "@/assets/images/user/logo4box10.png";
import logo4box11 from "@/assets/images/user/logo4box11.png";
import logo4box12 from "@/assets/images/user/logo4box12.png";
import logo4box13 from "@/assets/images/user/logo4box13.png";
import logo4box14 from "@/assets/images/user/logo4box14.png";
import logo4box15 from "@/assets/images/user/logo4box15.png";
import logo4box16 from "@/assets/images/user/logo4box16.png";
import logo4box17 from "@/assets/images/user/logo4box17.png";
import logo4box18 from "@/assets/images/user/logo4box18.png";
import logo4box19 from "@/assets/images/user/logo4box19.png";
import logo4box20 from "@/assets/images/user/logo4box20.png";
import logo4box21 from "@/assets/images/user/logo4box21.png";
import logo4box22 from "@/assets/images/user/logo4box22.png";
import logo4box23 from "@/assets/images/user/logo4box23.png";
import logo4box24 from "@/assets/images/user/logo4box24.png";
import logo4box25 from "@/assets/images/user/logo4box25.png";
import logo5box1 from "@/assets/images/user/logo5box1.png";
import logo5box2 from "@/assets/images/user/logo5box2.png";
import logo5box3 from "@/assets/images/user/logo5box3.png";
import logo5box1_1 from "@/assets/images/user/logo5box1-1.png";
import logo5box2_1 from "@/assets/images/user/logo5box2-1.png";
import logo5box3_1 from "@/assets/images/user/logo5box3-1.png";
// import logo5box4 from "@/assets/images/user/logo5box4.png";
import logo6box1 from "@/assets/images/user/logo6box1.png";
import logo6box2 from "@/assets/images/user/logo6box2.png";
import logo6box3 from "@/assets/images/user/logo6box3.png";
import logo6box4 from "@/assets/images/user/logo6box4.png";
import logo6box5 from "@/assets/images/user/logo6box5.png";
import logo6box6 from "@/assets/images/user/logo6box6.png";
import logo6box7 from "@/assets/images/user/logo6box7.png";
import logo6box8 from "@/assets/images/user/logo6box8.png";
// import logo7box1 from "@/assets/images/user/logo7box1.png";
// import logo7box2 from "@/assets/images/user/logo7box2.png";
import logo8box1 from "@/assets/images/user/logo8box1.png";
import mainLineBox from "@/assets/images/user/mainLineBox.svg";
import mainVideo from "@/assets/images/user/mainVideo.mp4";
import txtQuotes from "@/assets/images/user/txtQuotes.svg";
import LoadingSpinner from "@/components/common/common/LoadingSpinner";
import SubTitle from "@/components/user/common/SubTitle";
import UserPop from "@/components/user/popup/UserPop";
import { useGetInstagramList } from "@/service/user/main";

interface LogoGroup {
    title: string;
    /**
     * 2026 교체분 로고. 레이아웃(열 수·셀 비율)은 그대로 두고 간격만 시안(Figma 2469:8986)에 맞춘다.
     * - 타이틀↔로고 20px, 로고 세로 간격 0 (전 구간 동일)
     * - 로고 가로 간격: PC 60px(시안), 태블릿/모바일은 종전대로
     * 아직 교체 전인 그룹(협찬/참가 기관·기업/콜라보레이션)은 종전 간격을 쓴다.
     */
    padded?: boolean;
    logos: { src: string; alt: string }[];
}

const logoList: LogoGroup[] = [
    {
        title: "주 최",
        logos: [
            {
                src: logo1box1,
                alt: "성남시",
            },
        ],
    },
    {
        title: "주 관",
        logos: [
            {
                src: logo2box1,
                alt: "성남산업진흥원",
            },
            {
                src: logo2box2,
                alt: "게임문화재단",
            },
        ],
    },
    {
        title: "후 원",
        padded: true,
        logos: [
            {
                src: logo3box1,
                alt: "문화체육관광부",
            },
            {
                src: logo3box2,
                alt: "한국콘텐츠진흥원",
            },
            {
                src: logo3box3,
                alt: "게임물관리위원회",
            },
            {
                src: logo3box4,
                alt: "경기도",
            },
            {
                src: logo3box5,
                alt: "경기관광공사",
            },
            // 시안(Figma 2469:8986)상 기관 5곳 다음은 줄을 바꿔 기업 로고가 시작된다.
            // 빈 칸을 하나 넣어 6칸(PC)/3칸(태블릿)/2칸(모바일) 어디서든 기업 로고가 새 줄에서 시작하도록 맞춘다.
            {
                src: "",
                alt: "",
            },
            {
                src: logo3box6,
                alt: "넥슨",
            },
            {
                src: logo3box7,
                alt: "엔씨소프트",
            },
            {
                src: logo3box16,
                alt: "마이크로소프트",
            },
            {
                src: logo3box8,
                alt: "월드클래스",
            },
            {
                src: logo3box9,
                alt: "2NACCCO",
            },
            {
                src: logo3box10,
                alt: "창조공작소",
            },
            {
                src: logo3box17,
                alt: "펄어비스",
            },
            {
                src: logo3box18,
                alt: "플레이샵",
            },
            {
                src: logo3box11,
                alt: "호요버스",
            },
            // {
            //     src: logo3box12,
            //     alt: "레드프린팅",
            // },
            // {
            //     src: logo3box13,
            //     alt: "동아오츠카",
            // },
            // {
            //     src: logo3box14,
            //     alt: "마이크로소프트",
            // },
            // {
            //     src: logo3box15,
            //     alt: "클라우디드 레오파드 엔터테인먼트코리아",
            // },
        ],
    },
    {
        title: "협 찬",
        padded: true,
        logos: [
            {
                src: logo4box1,
                alt: "그래비티 조선 서울 판교",
            },
            {
                src: logo4box2,
                alt: "그레이츠 판교",
            },
            {
                src: logo4box3,
                alt: "네오위즈",
            },
            {
                src: logo4box4,
                alt: "네오플",
            },
            {
                src: logo4box5,
                alt: "넥슨게임즈",
            },
            {
                src: logo4box25,
                alt: "넷마블",
            },
            {
                src: logo4box22,
                alt: "동아오츠카",
            },
            {
                src: logo4box6,
                alt: "성남게임힐링센터",
            },
            {
                src: logo4box7,
                alt: "슈퍼셀",
            },
            {
                src: logo4box8,
                alt: "스마일게이트",
            },
            {
                src: logo4box9,
                alt: "스타라이크",
            },
            {
                src: logo4box23,
                alt: "스트리트 파이터",
            },
            {
                src: logo4box10,
                alt: "알파돔 타워",
            },
            {
                src: logo4box11,
                alt: "에피드게임즈",
            },
            {
                src: logo4box12,
                alt: "NC AI",
            },
            {
                src: logo4box13,
                alt: "NHN",
            },
            {
                src: logo4box14,
                alt: "웹젠",
            },
            {
                src: logo4box15,
                alt: "위메이드",
            },
            {
                src: logo4box16,
                alt: "카카오 아지트",
            },
            {
                src: logo4box17,
                alt: "크래프톤",
            },
            {
                src: logo4box24,
                alt: "2K",
            },
            {
                src: logo4box18,
                alt: "판교 테크원",
            },
            {
                src: logo4box19,
                alt: "포켓몬코리아",
            },
            {
                src: logo4box20,
                alt: "한국모바일게임협회",
            },
            {
                src: logo4box21,
                alt: "한림사",
            },
        ],
    },
    // {
    //     title: "협 찬",
    //     logos: [
    //         {
    //             src: logo4box1,
    //             alt: "굴뚝강아지",
    //         },
    //         {
    //             src: logo4box2,
    //             alt: "그래비티 조선 서울 판교",
    //         },
    //         {
    //             src: logo4box3,
    //             alt: "그레이츠 판교",
    //         },
    //         {
    //             src: logo4box4,
    //             alt: "네오위즈",
    //         },
    //         {
    //             src: logo4box5,
    //             alt: "데브시스터즈",
    //         },
    //         {
    //             src: logo4box6,
    //             alt: "성남게임힐링센터",
    //         },
    //         {
    //             src: logo4box7,
    //             alt: "스마일게이트",
    //         },
    //         {
    //             src: logo4box8,
    //             alt: "스타라이크",
    //         },
    //         {
    //             src: logo4box9,
    //             alt: "알파돔 타워",
    //         },
    //         {
    //             src: logo4box10,
    //             alt: "에피드게임즈",
    //         },
    //         {
    //             src: logo4box11,
    //             alt: "NHN",
    //         },
    //         {
    //             src: logo4box12,
    //             alt: "위메이드",
    //         },
    //         {
    //             src: logo4box13,
    //             alt: "카카오게임즈",
    //         },
    //         {
    //             src: logo4box14,
    //             alt: "카카오 아지트",
    //         },
    //         {
    //             src: logo4box15,
    //             alt: "크래프톤",
    //         },
    //         {
    //             src: logo4box16,
    //             alt: "판교 테크원",
    //         },
    //         {
    //             src: logo4box17,
    //             alt: "2K",
    //         },
    //         {
    //             src: logo4box18,
    //             alt: "플러디",
    //         },
    //         {
    //             src: logo4box19,
    //             alt: "한국모바일게임협회",
    //         },
    //         {
    //             src: logo4box20,
    //             alt: "한림사",
    //         },
    //     ],
    // },
    // {
    //     title: "참가 기관·기업",
    //     logos: [
    //         {
    //             src: logo6box1,
    //             alt: "동서울대학교",
    //         },
    //         {
    //             src: logo6box2,
    //             alt: "매직빈게임즈",
    //         },
    //         {
    //             src: logo6box3,
    //             alt: "바다",
    //         },
    //         {
    //             src: logo6box4,
    //             alt: "SYLO",
    //         },
    //         {
    //             src: logo6box5,
    //             alt: "신구대학교 게임콘텐츠과",
    //         },
    //         {
    //             src: logo6box6,
    //             alt: "오렌지커뮤니케이션즈",
    //         },
    //         {
    //             src: logo6box7,
    //             alt: "창조공작소",
    //         },
    //         {
    //             src: logo6box8,
    //             alt: "플래직",
    //         },
    //     ],
    // },
    {
        title: "참가 기관·기업",
        padded: true,
        logos: [
            {
                src: logo6box1,
                alt: "국립국악원",
            },
            {
                src: logo6box2,
                alt: "동서울대학교 메타버스게임애니메이션과",
            },
            {
                src: logo6box3,
                alt: "매직빈게임즈",
            },
            {
                src: logo6box5,
                alt: "신구대학교",
            },
            {
                src: logo6box4,
                alt: "Audia",
            },
        ],
    },
    {
        title: "콜라보레이션",
        padded: true,
        logos: [
            {
                src: logo5box1,
                alt: "인디크래프트",
            },
            {
                src: logo5box2,
                alt: "일러스타 페스",
            },
            {
                src: logo5box3,
                alt: "GV2026",
            },
            {
                src: logo5box1_1,
                alt: "포켓몬 카드 게임 2026 성남CITY 배틀 토너먼트",
            },
            {
                src: logo5box2_1,
                alt: "한국 서브컬처 공모전",
            },
            {
                src: logo5box3_1,
                alt: "AI GSDC",
            },
        ],
    },
    {
        title: "공식 음료",
        padded: true,
        logos: [
            {
                src: logo8box1,
                alt: "엑스코카스",
            },
        ],
    },
    // {
    //     title: "콜라보레이션",
    //     logos: [
    //         {
    //             src: logo5box1,
    //             alt: "인디크래프트",
    //         },
    //         {
    //             src: logo5box2,
    //             alt: "일러스타 페스",
    //         },
    //         {
    //             src: logo5box3,
    //             alt: "성남청년 플리마켓",
    //         },
    //         {
    //             src: logo5box4,
    //             alt: "GV2025",
    //         },
    //     ],
    // },
    // {
    //     title: "브랜드 파트너",
    //     logos: [
    //         {
    //             src: logo7box1,
    //             alt: "젠레스 존 제로",
    //         },
    //         {
    //             src: logo7box2,
    //             alt: "브롤스타즈",
    //         },
    //     ],
    // },
];

export default function Main() {
    const [day, setDay] = useState("");
    const sect2Ref = useRef<HTMLDivElement>(null);
    const sect3Ref = useRef<HTMLDivElement>(null);
    const [sect2On, setSect2On] = useState(false);
    const [sect3On, setSect3On] = useState(false);
    const [instaImgList, setInstaImgList] = useState<
        { media_url: string; thumbnail_url: string | null; permalink: string }[]
    >([]);
    const { data: configData, isLoading: isInitialLoading } = useGetInstagramList(1, 20);

    // 인스타그램 리스트 조회
    useEffect(() => {
        if (configData?.data?.posts) {
            setInstaImgList(configData.data.posts);
        } else {
            setInstaImgList([]);
        }
    }, [configData]);

    // 날짜 계산
    useEffect(() => {
        const today = new Date();
        const targetDate = new Date("2026-09-11");

        // 날짜 비교를 위해 시간을 00:00:00으로 설정
        today.setHours(0, 0, 0, 0);
        targetDate.setHours(0, 0, 0, 0);

        const difference = targetDate.getTime() - today.getTime();
        const daysRemaining = Math.ceil(difference / (1000 * 3600 * 24));

        let displayText;
        // 목표날짜일때만 D-Day 표시
        if (daysRemaining === 0 || daysRemaining === 1) {
            displayText = "D-Day";
        } else {
            const prefix = daysRemaining >= 0 ? "D-" : "D+";
            displayText = `${prefix}${Math.abs(daysRemaining)}`;
        }

        setDay(displayText);
    }, []);

    //스크롤시 section on
    const scrollSectOn = () => {
        const scroll = window.scrollY;
        const sections: {
            ref: React.RefObject<HTMLDivElement>;
            onSet: React.Dispatch<React.SetStateAction<boolean>>;
        }[] = [
            { ref: sect2Ref, onSet: setSect2On },
            { ref: sect3Ref, onSet: setSect3On },
        ];

        sections.forEach(({ ref, onSet }) => {
            if (ref.current) {
                const offsetTop = ref.current.offsetTop;
                if (scroll >= offsetTop - 600) {
                    onSet(true);
                }
            }
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollSectOn);

        return () => {
            window.removeEventListener("scroll", scrollSectOn);
        };
    }, []);

    return (
        <>
            <section className="relative block h-[100vh] min-h-[500px] overflow-hidden">
                <div className="relative flex h-full flex-col justify-end px-[24px] after:absolute after:-bottom-[1px] after:left-0 after:z-[20] after:size-[70px] after:border-[35px] after:border-white after:border-r-transparent after:border-t-transparent md:px-[40px] xl:px-0">
                    <div className="relative mx-auto h-[calc(100%-84px)] w-full max-w-[1600px] before:absolute before:left-0 before:top-0 before:z-[12] before:hidden before:h-full before:w-[1px] before:bg-[rgba(221,221,221,0.6)] md:h-[calc(100%-88px)] md:before:block xl:h-[calc(100%-117px)] [@media(min-height:800px)]:xl:h-full">
                        <div className="relative z-[20] flex h-full flex-col justify-center gap-[14%] before:absolute before:bottom-[13%] before:left-1/2 before:z-[12] before:hidden before:h-[1px] before:w-[100vw] before:-translate-x-1/2 before:bg-[rgba(221,221,221,0.6)] md:gap-[5%] md:before:block xl:flex-col-reverse xl:gap-0">
                            <div className="relative left-0 top-0 animate-slide-in-from-left font-['GongGothicMedium'] text-[50px] opacity-0 [animation-delay:500ms] md:-top-[60px] md:pl-[40px] md:text-[80px] xl:-top-[100px] xl:pl-[100px] xl:text-[clamp(70px,10vh,100px)]">
                                <img src={txtQuotes} alt="따옴표" className="w-[44px] md:w-auto" />
                                <p className="text-[72px] leading-[1.3] text-white md:text-[120px] xl:text-[clamp(100px,14vh,140px)]">
                                    게임,
                                </p>
                                <p>
                                    <span className="text-white">문화</span>
                                    <span className="text-transparent text-stroke-1-white">로 즐기다</span>
                                    <span className="text-primary">.</span>
                                </p>
                            </div>
                            <div className="flex animate-fade-in justify-end font-['GongGothicMedium'] font-[500] opacity-0 [animation-delay:500ms]">
                                <div className="relative text-right">
                                    <div className="relative flex flex-col pb-[5px] text-[18px] font-[500] leading-[1.5] text-white md:flex-row md:justify-between xl:text-[20px]">
                                        <p>2026.09.11. ~ 2026.09.12.</p>
                                        <p>2days</p>
                                    </div>
                                    <p className="relative text-[80px] font-[500] leading-[1.2] text-transparent text-stroke-1-white after:absolute after:bottom-0 after:left-0 after:h-[4px] after:w-[60px] after:bg-primary md:text-[140px] md:after:h-[8px] md:after:w-[120px] xl:text-[clamp(140px,18vh,180px)]">
                                        {day}
                                    </p>
                                </div>
                            </div>
                            <img
                                src={mainLineBox}
                                alt="이미지"
                                className="absolute bottom-[13%] left-0 z-[21] hidden -translate-x-1/2 translate-y-1/2 md:block"
                            />
                        </div>
                    </div>
                    <div className="absolute inset-0 h-full w-full animate-zoom-in after:absolute after:inset-0 after:h-full after:w-full after:bg-[rgba(0,0,0,0.4)]">
                        <video src={mainVideo} autoPlay muted loop playsInline className="h-full w-full object-cover" />
                    </div>
                </div>
            </section>
            <section className="pt-[80px] xl:pt-[160px]" ref={sect2Ref}>
                <div
                    className={`mx-auto w-full max-w-[1400px] px-[20px] opacity-0 xl:px-0${sect2On ? " animate-slide-in-from-bottom [animation-delay:250ms]" : ""}`}
                >
                    <div className="flex flex-col items-center gap-[16px] md:items-start xl:flex-row xl:items-center xl:justify-between">
                        <SubTitle title="INSTAGRAM UPDATE" />
                        <Link
                            to="https://www.instagram.com/gxg_gameculture/"
                            target="_blank"
                            className="flex h-[30px] items-center gap-[8px] rounded-[20px] px-[16px] font-['GongGothicLight'] text-[14px] text-[#666] shadow-[0_0_4px_rgba(124,101,219,0.20)]"
                        >
                            <img src={icInstagram} alt="인스타그램" />
                            <span>gxg_gameculture</span>
                        </Link>
                    </div>
                    {isInitialLoading ? (
                        <div className="flex h-[300px] items-center justify-center">
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <>
                            <ul className="grid grid-cols-2 gap-[8px] p-[40px_0_20px] md:grid-cols-3 md:gap-[14px] md:p-[60px_0_24px] xl:grid-cols-4 xl:gap-[12px]">
                                {instaImgList.map((item, index) => {
                                    return (
                                        <li
                                            key={`instagram_${index}`}
                                            className="group relative h-0 overflow-hidden rounded-[8px] pb-[130%]"
                                        >
                                            <a
                                                href={item.permalink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="absolute inset-0 block h-full w-full"
                                            >
                                                <img
                                                    src={item.thumbnail_url || item.media_url}
                                                    alt="인스타그램 이미지"
                                                    className="absolute inset-0 h-full w-full object-cover transition-all duration-500 group-hover:scale-[1.2]"
                                                />
                                                <div className="absolute inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.4)] opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                                                    <img src={arrowOutwardWhite2} alt="화살표" />
                                                </div>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                            <Link
                                to="https://www.instagram.com/gxg_gameculture/"
                                target="_blank"
                                className="flex h-[53px] w-full items-center justify-center gap-[12px] rounded-[8px] bg-[#F1F4F9] font-['GongGothicLight'] text-[18px] text-[#666]"
                            >
                                More
                                <img src={icPlus} alt="더보기" />
                            </Link>
                        </>
                    )}
                </div>
            </section>
            <section className="p-[80px_0_120px] xl:p-[160px_0]" ref={sect3Ref}>
                <ul
                    className={`mx-auto flex w-full max-w-[1400px] flex-col gap-[50px] px-[20px] opacity-0 xl:flex-row xl:flex-wrap xl:gap-x-[32px] xl:gap-y-[60px] xl:px-0${sect3On ? " animate-slide-in-from-bottom [animation-delay:250ms]" : ""}`}
                >
                    {logoList.map((item, index) => {
                        // index 0~1(주최/주관)은 제목과 로고가 한 줄에 붙는 2단 박스, 그 뒤는 전체 폭 박스.
                        const isWide = index > 1;
                        const isPadded = isWide && !!item.padded;
                        // 로고가 하나뿐인 그룹(공식 음료)은 md 미만에서 좌측 절반 칸에 홀로 걸려 보이므로 가운데 정렬한다.
                        const isSingle = item.logos.length === 1;

                        return (
                            <li
                                key={`logoBox_${index}`}
                                className={`p-[4px] ${isWide ? "w-full" : "xl:w-[calc(50%-16px)]"}`}
                            >
                                <div className="relative border border-[rgba(221,221,221,0.6)] p-[10px] before:absolute before:-left-[1px] before:top-[8px] before:h-[32px] before:w-[4px] before:-translate-x-full before:bg-primary after:absolute after:-top-[1px] after:left-[7px] after:h-[4px] after:w-[32px] after:-translate-y-full after:bg-primary">
                                    <div
                                        className={`relative flex flex-col items-center p-[30px_20px_40px] before:absolute before:-bottom-[1px] before:-right-[11px] before:h-[32px] before:w-[4px] before:translate-x-full before:bg-primary after:absolute after:-bottom-[11px] after:-right-[2px] after:h-[4px] after:w-[32px] after:translate-y-full after:bg-primary md:p-[30px_60px] xl:p-[40px_50px] ${isPadded ? "gap-[20px] md:items-start" : isWide ? "gap-[35px] md:items-start md:gap-[40px]" : "gap-[35px] md:flex-row md:gap-0"}`}
                                    >
                                        <p
                                            className={`font-['GongGothicMedium'] text-[24px] font-[700] text-black md:text-[32px]${isWide ? "" : " md:w-[180px]"}`}
                                        >
                                            {item.title}
                                        </p>
                                        <ul
                                            className={`flex w-full items-center ${
                                                isPadded
                                                    ? `flex-wrap gap-x-[24px] gap-y-0 md:gap-x-[40px] xl:gap-x-[60px] ${isSingle ? "justify-center md:justify-start" : "justify-start"}`
                                                    : isWide
                                                      ? "flex-wrap justify-start gap-[24px] md:gap-[40px] xl:gap-x-[40px] xl:gap-y-[40px]"
                                                      : "justify-center gap-[24px] md:flex-1 md:justify-start md:gap-x-[60px]"
                                            }`}
                                        >
                                            {item.logos.map((logo, logoIndex) => (
                                                <li
                                                    key={`logo_${logoIndex}`}
                                                    className={`flex w-[calc(50%-12px)] justify-center ${isWide ? `md:w-[calc(33.333%-26.666px)] md:max-xl:[&:nth-child(3n)]:justify-end md:max-xl:[&:nth-child(3n+1)]:justify-start ${isPadded ? "xl:w-[calc(16.666%-50px)]" : "xl:w-[calc(16.666%-33.333px)]"}` : "md:w-[calc(50%-30px)]"}`}
                                                >
                                                    {logo.src ? (
                                                        <img src={logo.src} alt={logo.alt} />
                                                    ) : (
                                                        <span className="block h-[48px] w-full" />
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </section>
            <UserPop />
        </>
    );
}
